<template lang="pug">
    include ../helpers/pug/mixins
    +b.rsl-viewer-menu
        +e.UL.list
            +e.LI.item(
                v-for="item in navList"
                :key="item.name"
                :class="itemClass(item)"
            )
                +e.BUTTON.btn(
                    type='button'
                    v-bind:data-counter="item.count"
                    v-bind:class="{'rsl-viewer-menu__btn_has_count' : item.count}"
                    @click="changeMenuItem(item)"
                )
                    +e.SVG.icon
                        title {{item.title}}
                        use(:xlink:href="item.icon")
</template>

<script>
export default {
    props: {
        /*
             * В основе лежит массив с объектами, который представляет из себя пункты меню
             * navList:
             * @param {String} icon - ссылка на иконку для пункта.
             * @param {String} name - Идентификатор компонента
             * @param {String} component - Название компонента
             * @param {String} title - отвечает за всплывающую подсказку таба
             * @param {Boolean} isActive - показатель того, активен пункт или нет
             * @param {Boolean} isDisabled - показатель того, доступен пункт или нет
             * @param {Boolean} hasTopBorder - показатель того, есть граница сверху или нет
             */
        navList: {
            type: Array,
            required: true,
            default() {
                return [];
            }
        },
        currentTab: {
            type: String,
            required: true,
            default: ''
        },
        theme: {
            type: String,
            required: false,
            default: 'gray'
        }
    },
    methods: {
        itemClass(item) {
            return [
                { 'rsl-viewer-menu__item_active': item.name === this.currentTab },
                { 'rsl-viewer-menu__item_disabled': item.isDisabled },
                { 'rsl-viewer-menu__item_top_border': item.hasTopBorder },
                `rsl-viewer-menu__item_${this.theme}`
            ];
        },
        changeMenuItem(item) {
            if (!item.isDisabled) this.$emit('newComponent', item.name);
        }
    }
};
</script>

<style lang="sass" src="./rsl-viewer-menu.sass"></style>
